module.exports = __webpack_public_path__ + "files/d4a7fdd9272bc4e197ea9523e9b2aede.png";